"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
  query getConfiguratorService(
    $salesModelId: Int!
    $zipcode: String
    $filters: NavFilters
  ) {
    configurator(
      salesModelId: $salesModelId
      zipCode: $zipcode
      filters: $filters
    ) {
      salesModelId
      configurator {
        configuratorId
        version
        configuratorGuid
        navs {
          navId
          name
          ordinal
          whitelistedSelections
          icon
          navType
          optionGroups {
            optionGroupId
            ordinal
            isHeaderVisible
            title
            subText
            configuratorOptions {
              configuratorOptionId
              optionType
              ordinal
              title
              subText
              helpText
              shortName
              selections {
                selectionId
                ordinal
                title
                subText
                helpText
                icon
                price
                shortName
              }
            }
          }
          scenes {
            sceneId
            sceneName
          }
        }
      }
    }
  }
`;exports.getConfigurator=e;
//# sourceMappingURL=queries.js.map
